module.exports = __webpack_public_path__ + "static/media/Parkwoods_DCCR_Amendment.20d98677.pdf";